import axios from '../../../plugins/axios-common'

export default {
    namespaced: true,
    state: {
        isFirstTab: true,
        url: '/calc/',
        availableTire:[
            12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24
        ],
        tireHeight: [ '30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85' ],
        tireWidth: [ '155', '165', '175', '185', '195', '205', '215', '225', '235', '245', '255', '265', '275', '285', '295', '305', '315', '325', '335', '345' ],
        availableTireState: ['Новая', 'Хорошее', 'Среднее', 'Плохое'],
        availableWheelDiskState: ['Новый', 'Хорошее', 'Среднее', 'Плохое'],
        seasons: ['зимняя','летняя','всесезонная'],
        cap: ['родной','не родной','отсутствует','не указан'],
        availableProfile: Array.from({length: 15}, (_, i) => i+1),
        availableTireMark: [],
        seal: '',
        licensePlate: '',
        storagePeriod: 1,
        QRcodeUrl: '/QR.png',
        wheels:{
            forwardLeft: {
                isActive: true,
                data: {}
            },
            forwardRight: {
                isActive: true,
                data: {}
            },
            backLeft: {
                isActive: true,
                data: {}
            },
            backRight: {
                isActive: true,
                data: {}
            },
            spareLeft: {
                isActive: false,
                data: {}
            },
            spareRight: {
                isActive: false,
                data: {}
            },
        }
    },
    mutations: {
        setIsFirstTab (state, value) {
            state.isFirstTab = value
        },
        addData (state, payload) {
            const {value, side} = payload;
            state.wheels[side].data = JSON.parse(JSON.stringify(value))
        },
        setPlus (state, payload) {
            const {value, item, side} = payload;
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data[item] = value
                }
            } else {
                state.wheels[side].data[item] = value
            }
        },
        setRadius(state, payload) {
            const {value, side} = payload;
            state[side].data.radius = value
        },
        setIsTire(state, payload) {
            const {value, side} = payload;
            state[side].data.isTire = value
        },
        setTireMark(state, payload) {
            const {value, side} = payload;
            state[side].data.tireMark = value
        },
        setTireSeason(state, payload) {
            const {value, side} = payload;
            state[side].data.tireSeason = value
        },
        setTireState(state, payload) {
            const {value, side} = payload;
            state[side].data.tireState = value
        },
        setTireWidth(state, payload) {
            const {value, side} = payload;
            state[side].data.tireWidth = value
        },
        setTireHeight(state, payload) {
            const {value, side} = payload;
            state[side].data.tireHeight = value
        },
        setTireProfile(state, payload) {
            const {value, side} = payload;
            state[side].data.tireProfile = value
        },
        setIsWheelDisk(state, payload) {
            const {value, side} = payload;
            state[side].data.isWheelDisk = value
        },
        setWheelDiskType(state, payload) {
            const {value, side} = payload;
            state[side].data.wheelDiskType = value
        },
        setHubcap(state, payload) {
            const {value, side} = payload;
            state[side].data.hubcap = value
        },
        setWheelDiskState(state, payload) {
            const {value, side} = payload;
            state[side].data.wheelDiskState = value
        },
        setStoragePeriod(state, payload) {
            state.storagePeriod = payload
        },
        setSeal(state, payload) {
            state.seal = payload
        },
        setLicensePlate(state, payload) {
            state.licensePlate = payload
        },
        setTyremarks(state, payload) {
            state.availableTireMark = [...payload]
        },
        setIsActive(state, payload) {
            const {value, side} = payload;
            state.wheels[side].isActive = value
        },
        setSideParam(state, payload) {
            state[payload.sideName].data = payload.data
        },
        resetSealAndLicensePlate(state) {
            state.seal = ''
            state.licensePlate = ''
            state.storagePeriod = 1
        }
    },
    actions: {
        async init({ rootState, getters, commit }) {
            let data = {
                radius: parseInt(rootState.clientCard.diskSize.replace('R','')),
                solidDisk: rootState.clientCard.diskType!=="shtamp",
                isRunflat: rootState.clientCard.runflat,
                tireMark: '',
                isTire: true,
                tireWidth: null,
                tireState: '',
                tireHeight: null,
                tireProfile: null,
                isWheelDisk: false,
                hubcap: 'родной',
                wheelDiskState: '',
            }
            getters.sides.forEach(side => {
                commit('addData', {side: side.sideName, value:data})
            });
        },
        getTireMarks ({ commit, state }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: state.url + 'tyremarks.json',
                })
                    .then((response) => {
                        commit('setTyremarks', response.data)
                        resolve(response.data)
                    }).catch((e) => {
                    reject(e)
                })
            })
        },
        changeActiveWheels({commit}, payload) {
            for (const side in payload) {
                commit('setIsActive', {side, value: payload[side]})
            }
        },
        copySide({commit, getters, state}, payload) {
            let sideName;
            switch (payload) {
                case 'fl':
                    sideName = 'forwardLeft';
                    break;
                case 'fr':
                    sideName = 'forwardRight';
                    break;
                case 'bl':
                    sideName = 'backLeft';
                    break;
                case 'br':
                    sideName = 'backRight';
                    break;
                case 'sl':
                    sideName = 'spareLeft';
                    break;
                case 'sr':
                    sideName = 'spareRight';
                    break;
                default:
                    sideName = payload
            }
            const sides = getters.sides;
            for(const side in sides) {
                if(side.sideName !== sideName) {
                    commit('setSideParam', {sideName: sides[side].sideName, data: {...state[sideName].data}})
                }
            }
        },
        changeRadius({commit, state}, payload) {
            commit('setRadius', payload);
            const radius = payload.value.find(value => value.selected).value;
            const optionsWidth = state.availableTire
                .find(availableRadius => availableRadius.value === radius).profiles
                .map(profile => ({text: profile.width, value: profile.width, selected: false}));
            commit('setTireWidth', {side: payload.side, value: optionsWidth});
            const optionsHeight = state.availableTire
                .find(availableRadius => availableRadius.value === radius).profiles
                .map(profile => ({text: profile.height, value: profile.height, selected: false}));
            commit('setTireHeight', {side: payload.side, value: optionsHeight})
        }
    },

    getters: {
        activeSides: (state, getters) => getters.sides.filter(side => side.isActive),
        sides: state => [
            {...state.forwardLeft, sideName: 'forwardLeft'},
            {...state.forwardRight, sideName: 'forwardRight'},
            {...state.backLeft, sideName: 'backLeft'},
            {...state.backRight, sideName: 'backRight'},
            {...state.spareLeft, sideName: 'spareLeft'},
            {...state.spareRight, sideName: 'spareRight'},
        ],
        selectedRadius: (state) => {
            const forwardLeft = state.forwardLeft.data.radius.find(radius => radius.selected === true);
            const forwardRight = state.forwardRight.data.radius.find(radius => radius.selected === true);
            const backLeft = state.backLeft.data.radius.find(radius => radius.selected === true);
            const backRight = state.backRight.data.radius.find(radius => radius.selected === true);
            const spareLeft = state.spareLeft.data.radius.find(radius => radius.selected === true);
            const spareRight = state.spareRight.data.radius.find(radius => radius.selected === true);

            return {
                forwardLeft: forwardLeft ? forwardLeft.value : undefined,
                forwardRight: forwardRight ? forwardRight.value : undefined,
                backLeft: backLeft ? backLeft.value : undefined,
                backRight: backRight ? backRight.value : undefined,
                spareLeft: spareLeft ? spareLeft.value : undefined,
                spareRight: spareRight ? spareRight.value : undefined
            }
        },
        numberOfWheelsByRadius: (state, getters) => getters.activeSides.reduce((res, side) => {
            const radius = res.find(item => item.radius === getters.selectedRadius[side.sideName]);
            if (radius) {
                radius.number = radius.number + 1
            } else {
                res.push({radius: getters.selectedRadius[side.sideName], number: 1})
            }
            return res
        }, []),
        selectedTireState: (state) => {
            const forwardLeft = state.forwardLeft.data.tireState.find(tireState => tireState.selected === true);
            const forwardRight = state.forwardRight.data.tireState.find(tireState => tireState.selected === true);
            const backLeft = state.backLeft.data.tireState.find(tireState => tireState.selected === true);
            const backRight = state.backRight.data.tireState.find(tireState => tireState.selected === true);
            const spareLeft = state.spareLeft.data.tireState.find(tireState => tireState.selected === true);
            const spareRight = state.spareRight.data.tireState.find(tireState => tireState.selected === true);

            return {
                forwardLeft: forwardLeft ? forwardLeft.text : undefined,
                forwardRight: forwardRight ? forwardRight.text : undefined,
                backLeft: backLeft ? backLeft.text : undefined,
                backRight: backRight ? backRight.text : undefined,
                spareLeft: spareLeft ? spareLeft.text : undefined,
                spareRight: spareRight ? spareRight.text : undefined
            }
        },

    },
}
